import React from 'react';
import { Input, InputProps } from 'antd';
import { twMerge } from 'tailwind-merge';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

interface Props {
  className?: string;
  classNameLabel?: string;
  classNameInput?: string;
  label?: string;
  error?: string;
  onChange?: (e) => void;
  name?: string;
  required?: boolean;
}

export function InputPassword(props: Props & InputProps) {
  const { className, classNameLabel, label, classNameInput, name, error, required, ...prop } =
    props;

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className={twMerge('text-gray_800 text-sm mb-2 block', classNameLabel)}
        >
          {label}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      )}
      <Input.Password
        size="large"
        name={name}
        className={twMerge('border border-gray_300', classNameInput)}
        iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
        {...prop}
      />
      {error && <span className="text-sm text-error">{error}</span>}
    </div>
  );
}
